/* ============================================================
   NL Invisible Lift — before/after comparison slider
   Drives the handle on [data-nl-ba]; the position is published
   as the --nl-ba-pct custom property and the CSS does the rest
   (clip-path on the "after" layer, left on the line and knob).
   Loaded by the "What Makes It" section.
   ============================================================ */
(function () {
  'use strict';
  if (window.__nlIlBaReady) return;
  window.__nlIlBaReady = true;

  function pctFrom(el, clientX) {
    var r = el.getBoundingClientRect();
    if (!r.width) return 50;
    return Math.max(0, Math.min(100, ((clientX - r.left) / r.width) * 100));
  }

  function set(el, pct) {
    el.style.setProperty('--nl-ba-pct', pct + '%');
    el.setAttribute('aria-valuenow', Math.round(pct));
  }

  function bind(el) {
    if (el.hasAttribute('data-nl-ba-ready')) return;
    el.setAttribute('data-nl-ba-ready', '');
    var dragging = false;

    el.addEventListener('pointerdown', function (e) {
      dragging = true;
      if (el.setPointerCapture) { try { el.setPointerCapture(e.pointerId); } catch (err) {} }
      set(el, pctFrom(el, e.clientX));
      e.preventDefault(); // stops text selection and native image drag
    });
    el.addEventListener('pointermove', function (e) {
      if (dragging) set(el, pctFrom(el, e.clientX));
    });
    var stop = function () { dragging = false; };
    el.addEventListener('pointerup', stop);
    el.addEventListener('pointercancel', stop);
    el.addEventListener('lostpointercapture', stop);

    // keyboard: the container is role="slider" and focusable
    el.addEventListener('keydown', function (e) {
      var cur = parseFloat(el.getAttribute('aria-valuenow'));
      if (isNaN(cur)) cur = 50;
      var step = e.shiftKey ? 10 : 2;
      if (e.key === 'ArrowLeft') { set(el, Math.max(0, cur - step)); }
      else if (e.key === 'ArrowRight') { set(el, Math.min(100, cur + step)); }
      else if (e.key === 'Home') { set(el, 0); }
      else if (e.key === 'End') { set(el, 100); }
      else { return; }
      e.preventDefault();
    });
  }

  function init() {
    var all = document.querySelectorAll('[data-nl-ba]');
    for (var i = 0; i < all.length; i++) bind(all[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // the theme editor re-renders the section when a setting changes
  document.addEventListener('shopify:section:load', init);
})();
